import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Login } from '@mui/icons-material';
import { PrimaryButton } from '@/components/index';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppConfig } from '@/hooks';
import logo from '@/assets/LogistX.jpg';

const LoginPage: React.FC = () => {
  const { isAuthenticated, isLoading, login } = useAuth();
  const config = useAppConfig();
  const location = useLocation();
  const signInLabel = config.authProvider === 'oidc' ? 'Sign in with identity provider' : 'Sign in with Azure AD';

  // Redirect to intended page or dashboard if already authenticated
  if (isAuthenticated) {
    const from = (location.state as { from?: { pathname?: string } })?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: 'calc(79vh)', // Account for header and padding and notifications
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <img
            src={logo}
            alt="LogistX Logo"
            style={{
              height: '48px',
              width: 'auto',
              marginBottom: '12px',
            }}
          />
          <Typography variant="h5" component="h1" gutterBottom>
            {config?.appTitle || 'BOL Backoffice'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please sign in to access the application
          </Typography>
        </Box>

        <PrimaryButton
          size="large"
          fullWidth
          onClick={handleLogin}
          loading={isLoading}
          startIcon={<Login />}
          sx={{ mt: 2, py: 1.2 }}
        >
          {isLoading ? 'Signing in...' : signInLabel}
        </PrimaryButton>
      </Paper>
    </Box>
  );
};

export default LoginPage;